import { Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';

import { colors } from 'src/global/styles/colors';

import { OTCNodesSoldChart } from './OTCNodesSoldChart';
import { OTCRevenueChart } from './OTCRevenueChart';
import { OTCStatisticsTable } from './OTCStatisticsTable';

export function OTCSalesSection() {
  return (
    <Stack spacing={3}>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Gotham',
          fontWeight: 700,
          fontSize: '24px',
          color: colors.white,
          lineHeight: 1.17,
        }}>
        OTC Sales
      </Typography>

      {/* OTC Statistics Table */}
      <OTCStatisticsTable />

      {/* Charts Row */}
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <OTCNodesSoldChart />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <OTCRevenueChart />
        </Grid2>
      </Grid2>
    </Stack>
  );
}
